import clsx from "clsx";
import pluralize from "pluralize";

import { TopTip } from "@/components/molecules/TopTip";
import { ColorEnum } from "@/enums";
import { CommonProps } from "@/types";
import { createId } from "@/utils/helpers";

import styles from "./Rating.module.css";

const ref = "rating";

interface RatingProps extends Partial<CommonProps> {
  count: number;
  rating: number;
}

function useRating(props: RatingProps) {
  const className = clsx(styles[ref], props.className);
  const { id = createId(ref), rating } = props;

  return {
    className,
    count: props.count,
    id,
    rating: rating.toFixed(1),
  };
}

function Rating(props: RatingProps) {
  const { className, count, id, rating } = useRating(props);

  if (count === 0) {
    return null;
  }

  return (
    <section className={className} id={id}>
      <TopTip color={ColorEnum.GREEN} text={rating} uniform />
      <span className={styles.count}>({pluralize("golfer", count, true)})</span>
    </section>
  );
}

export default Rating;
export { Rating, type RatingProps };
